import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkPermission } from "./permissionHelper";
import { setToast } from "./toast";

/**
 * A wrapper component for protected routes that checks for module-level permissions.
 * 
 * @param {React.ReactNode} children - The component(s) to render if permitted.
 * @param {string} module - The module name to check against user permissions.
 * @param {string} action - The action to check (defaults to "List").
 * @returns {React.ReactNode} - Children if permitted, otherwise a redirect to Dashboard.
 */
const ProtectedRoute = ({ children, module, action = "List" }) => {
  const { admin, loginType, permissions } = useSelector((state) => state.admin);

  // Use the existing permission helper to check access
  const hasPermission = checkPermission(admin, loginType, permissions, module, action);

  if (!hasPermission) {
    // Show unauthorized toast message
    setToast("error", "You are not authorized to access this module");
    
    // Redirect to Dashboard or another safe page
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
